export function formatBytes(bytes, decimals = 1) {
    if (bytes === 0) return '0 B';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}


export function formatDateTime(datetimeString) {
    if (!datetimeString) {
        return ''; // Or return a placeholder like 'N/A'
    }
    try {
        const date = new Date(datetimeString);
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            console.error("Invalid date string provided:", datetimeString);
            return 'Invalid Date';
        }
        // Format the date and time. Example: "4/3/2025, 12:06:03 PM"
        // Adjust options as needed for your desired table format
        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            // You can add or remove options like timeZoneName: 'short' if needed
        });
    } catch (error) {
        console.error("Error formatting date:", error);
        return 'Error'; // Return an error indication
    }
}

export function formatMatch(score) {
    return (score * 100).toFixed(2);
}